// eslint-disable-next-line import/no-cycle
import { post, get } from 'utils/methods';

export function getCoatingOutApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}machine-job-palettes`, data, headers);
}

export function getJobPalettesOutApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}job-palettes`, data, headers);
}

export function createJobPaletteCoatingOutApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/job-palette`, data, headers);
}
